import { Field, Int, ObjectType } from '@nestjs/graphql'

/**
 * How well a book fits one of the categories its author picked, as judged by AI from the blurb [sc-28740]. Only
 * staff see these: the one place they are exposed is the staff-only Recommended score breakdown on `ArcDto`.
 */
@ObjectType()
export class BookCategoryFitDto {
  @Field(t => Int)
  categoryId!: number

  /** 0-100, or null when the blurb is too short to judge or the last attempt failed. */
  @Field(t => Int, { nullable: true })
  score?: number | null

  /** The model's one-line reason for the score. */
  @Field({ nullable: true })
  reason?: string | null
}
